/* eslint-disable max-len */
import styled from 'styled-components';
import TransferInIconDark from '../../assets/images/transfer-in-icon.svg';
import TransferInIconLight from '../../assets/images/transfer-in-icon-light.svg';

const TransferInIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${TransferInIconDark}") no-repeat left center`
      : `url("${TransferInIconLight}") no-repeat left center`};
  background-size: 27px 16px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 16px;
  width: 27px;
`;

export default TransferInIcon;
